import { scanForProperty } from "../utils/utility";
import { REGION_CODE } from "./constants";

export const orderDissection = order => {
    if (!order) return null;
    
    const downloadableReports = [];
    const possibleReportTypes = ["cod", "serialAudit", "productFile", "invoice"];  
    
    const orderCompleted = order.status && order.status.toUpperCase() === "COMPLETED";  
    const orderReports = order.reports;
    const orderFiles = order.orderFiles || [];
    const pickUpQuestionnaireData = order.pickUpQuestionnaireData;
    const completedByExt = order.completedByExt || false;
    
    const regionCode = order.region || REGION_CODE;
    const AMS = regionCode === "AMS";
    const EMEA = regionCode === "EMEA";
    const APJ = regionCode === "APJ";

    possibleReportTypes.forEach(type => {
        let reportAvailable = false;
        let generateReportAtClient = false;
        let reportFormat = "xls";
        let reportUrl = "";
        let reportName = "";

        if (type === "cod" && orderCompleted) {
            const certOfDest = scanForProperty(pickUpQuestionnaireData, "certOfDest");

            if (AMS) {
                if (orderReports && (orderReports.codFileFormat && orderReports.codFileUrl && orderReports.codReport)) {
                    reportAvailable = true;
                    reportFormat = orderReports.codFileFormat;
                    reportUrl = orderReports.codFileUrl;
                }
            }
            else {
                if (!((AMS || EMEA) && certOfDest === "Y" && completedByExt)) {
                    generateReportAtClient = true;
                }

                reportAvailable = true;
                reportFormat = "pdf";
            }
        }

        if (type === "serialAudit" && orderCompleted) {
            const serialNoAudit = scanForProperty(pickUpQuestionnaireData, "serialNoAudit");

            if ((AMS || EMEA) && completedByExt && serialNoAudit === "Y") {
                reportAvailable = true;
                reportFormat = "pdf";
            }
            else {
                if (orderReports && (orderReports.serialFileFormat && orderReports.serialAuditFileUrl && orderReports.serialAuditReport)) {
                    reportAvailable = true;
                    reportFormat = orderReports.serialFileFormat;
                    reportUrl = orderReports.serialAuditFileUrl;
                }
            }            
        }

        if (type === "productFile") {
            const productFileData = orderFiles.filter(data => data.fileType === "product");
            if (productFileData.length) {
                reportAvailable = true;
                reportFormat = productFileData[0].fileFormat;
                reportUrl = productFileData[0].fileContent;
                reportName = productFileData[0].fileDescription;
            }
        }

        if (type === "invoice") {
            const invoiceFileData = orderFiles.filter(data => data.fileType === "invoice");
            if (invoiceFileData.length) {
                reportAvailable = true;
                reportFormat = invoiceFileData[0].fileFormat;
                reportUrl = invoiceFileData[0].fileContent;
                reportName = invoiceFileData[0].fileDescription;
            }
        }

        if (reportAvailable) {
            downloadableReports.push({
                type: type,
                generateAtClient: generateReportAtClient,
                format: reportFormat.toLowerCase(),
                url: reportUrl,
                name: reportName
            });
        }
    });

    return {
        downloadableReports: downloadableReports
    };
}